import util from '@bmp-vue/core/api/util'

const controller = 'Correntistas'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByDocumento: function (documentoFederal) {
    return util.Axios.Get(controller + '/GetByDocumento', documentoFederal)
  },
  GetComRelacionamentos: function (id) {
    return util.Axios.Get(controller + '/GetComRelacionamentos', id)
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  ObterTitularConta: function (codigoConta) {
    return util.Axios.Get(controller + `/TitularConta/${codigoConta}`)
  },
  DownloadArquivo: function (localArquivo) {
    return util.Axios.Get(controller + `/Documentos?localArquivo=${localArquivo}`)
  },
  InserirArquivo: function (request) {
    return util.Axios.Post(controller + '/Documentos', request)
  },
  InserirTermo: function (dto) {
    return util.Axios.Post(controller + '/TermoAceite', dto);
  },
  ObterCorrentistaSolicitacao: function (codigoPessoaDado) {
    return util.Axios.Get(controller + '/CorrentistaSolicitacao', codigoPessoaDado)
  }
})
